import React, {SyntheticEvent, FC} from 'react';
import {connect} from 'react-redux';

import {Animation, FADE_TOP} from 'components/__helpers/animation/animation';
import {MenuConnected} from 'features/menu/menu';
import {ApplicationStoreType} from 'constants/flow/flowTypes';
import {toggleSearch} from 'reducers/header/header';
import {isQuickSearchVisible as isQuickSearchVisibleSelector} from 'selectors/quickSearch/quickSearch';
import {Sticky} from 'components/sticky/sticky';
import {isPageWithStickyHeader} from 'selectors/pageApp/pageApp';
import {defaultStructure} from 'features/menu/menuStructure';

import s from './quickSearchSticky.scss';
import {QuickSearchConnected} from '../quickSearch/quickSearch';

export type PropsType = {
    isQuickSearchVisible: boolean;
    isSticky: boolean;
    onSearchButtonClick: (arg?: SyntheticEvent) => void;
    page?: string;
};

/**
 * StickyElementsFromHeader - elements those used in websiteHeader component
 * @param {PropsType} props - component properties
 * @return {FC<PropsType>} rendered component
 */
export const HeaderStickyElements: FC<PropsType> = ({
    isQuickSearchVisible,
    onSearchButtonClick,
    isSticky,
    page = '',
}: PropsType) => {
    const pagesWithoutSearch = [
        'cart',
        'checkout',
        'successPage',
        'postPurchaseInsurance',
        'quizResults',
    ];

    if (pagesWithoutSearch.includes(page)) return null;

    return (
        <>
            <Sticky enabled={isSticky} offset={35} isForceStuck={isQuickSearchVisible}>
                <div className={s.quickSearch}>
                    <Animation in={isQuickSearchVisible} name={FADE_TOP}>
                        <QuickSearchConnected close={onSearchButtonClick} />
                    </Animation>
                </div>
            </Sticky>
            <MenuConnected structure={defaultStructure} />
        </>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
export const mapStateToProps = (store: ApplicationStoreType) => ({
    isQuickSearchVisible: isQuickSearchVisibleSelector(store),
    isSticky: isPageWithStickyHeader(store),
});

export const mapDispatchToProps = {
    onSearchButtonClick: toggleSearch,
};

export const HeaderStickyElementsConnected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(HeaderStickyElements);
